export default __webpack_public_path__ + "static/media/landing_bg.647a8dc5.png";